import { SECTION_KEYS } from './sections';
import AccountInfoCard from '../components/AccountInfoCard';
import BusinessInfoCard from '../components/BusinessInfoCard';
import ContactInfoCard from '../components/ContactInfoCard';
import MailingAddressCard from '../components/MailingAddressCard';
import PaymentInfoCard from '../components/PaymentInfoCard';
import PrincipalAddressCard from '../components/PrincipalAddressCard';

export const SECTION_COMPONENTS = {
  [SECTION_KEYS.ACCOUNT_INFO]: AccountInfoCard,
  [SECTION_KEYS.BUSINESS_INFO]: BusinessInfoCard,
  [SECTION_KEYS.CONTACT_INFO]: ContactInfoCard,
  [SECTION_KEYS.MAILING_ADDRESS]: MailingAddressCard,
  [SECTION_KEYS.PAYMENT_INFO]: PaymentInfoCard,
  [SECTION_KEYS.PRINCIPAL_ADDRESS]: PrincipalAddressCard
};
